import { useMutation } from '@tanstack/react-query'

import { registerTransactionEvidenceEmailAddress } from '@src/api'
import { DefaultApiRegisterTransactionEvidenceEmailAddressRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useRegisterTransactionEvidenceEmailAddress = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (
      params: DefaultApiRegisterTransactionEvidenceEmailAddressRequest
    ) => registerTransactionEvidenceEmailAddress(axiosInstance, params),
  })
}
